var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCasino(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.53658 17.5608C9.36531 17.5597 10.1652 17.2568 10.7868 16.7087C11.4083 16.1605 11.8088 15.4047 11.9135 14.5826C12.0181 13.7605 11.8197 12.9285 11.3553 12.2421C10.8908 11.5557 10.1923 11.0621 9.39027 10.8534C9.5122 8.90226 7.92683 7.31689 5.97561 7.31689C4.02439 7.31689 2.43903 8.90226 2.56098 10.8534C1.09756 11.0974 0 12.4389 0 14.0242C0 15.9754 1.58536 17.4388 3.41463 17.4388C4.02439 17.4388 4.63415 17.3169 5.12195 16.951V19.1462H4.2683C3.78048 19.1462 3.41463 19.512 3.41463 19.9998C3.41463 20.4877 3.78048 20.8535 4.2683 20.8535H7.68293C8.17073 20.8535 8.53658 20.4877 8.53658 19.9998C8.53658 19.512 8.17073 19.1462 7.68293 19.1462H6.82927V16.951C7.31707 17.3169 7.92683 17.5608 8.53658 17.5608Z",
    fill: "#dd9937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0487 8.41486C22.6829 8.17096 22.1951 8.17096 21.9512 8.41486C18.9024 11.0978 16.4634 12.6832 16.4634 15.2441C16.4634 17.3173 17.9268 18.9027 19.878 18.9027C20.4878 18.9027 21.0976 18.7807 21.5853 18.4149V20.3661H20.7317C20.2438 20.3661 19.878 20.7319 19.878 21.2197C19.878 21.7076 20.2438 22.0734 20.7317 22.0734H24.1463C24.6341 22.0734 24.9999 21.7076 24.9999 21.2197C24.9999 20.7319 24.6341 20.3661 24.1463 20.3661H23.2927V18.4149C23.7805 18.7807 24.3902 18.9027 24.9999 18.9027C26.9512 18.9027 28.4146 17.1953 28.4146 15.2441C28.5365 12.6832 26.2195 11.0978 23.0487 8.41486Z",
    fill: "#dd9937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6466 0C9.69538 0 8.23193 1.70732 8.23193 3.65854C8.23193 6.21951 10.549 7.80487 13.7198 10.4878C14.0856 10.7317 14.5734 10.7317 14.8173 10.4878C17.8661 7.80487 20.1831 6.21951 20.1831 3.65854C20.1831 1.58536 18.7197 0 16.7685 0C15.7929 0 14.8173 0.487805 14.2075 1.34147C13.4758 0.487805 12.6222 0 11.6466 0Z",
    fill: "#ec171f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5125 17.6523C14.1466 17.2865 13.5368 17.2865 13.2929 17.6523L8.41486 23.1401C8.17096 23.506 8.17096 23.9938 8.41486 24.2377L13.2929 29.7255C13.6587 30.0913 14.2685 30.0913 14.5125 29.7255L19.6344 24.2377C19.8782 23.8718 19.8782 23.384 19.6344 23.1401L14.5125 17.6523Z",
    fill: "#ec171f"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_9",
    x1: 8.15724,
    y1: -1.20046,
    x2: 18.6342,
    y2: 11.8539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.060883,
    stopColor: "#ec171f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA006F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_9",
    x1: 8.15953,
    y1: 15.958,
    x2: 20.8505,
    y2: 28.9171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.060883,
    stopColor: "#ec171f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec171f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasino);
export default __webpack_public_path__ + "static/media/casino.0886d23dcb426c1d00991b1612d474a2.svg";
export { ForwardRef as ReactComponent };